import { DataTableColumns } from '@tq/ui-components';
import { FormatLocaleDateReturnType } from 'config/DateFormats/useFormatLocaleDate';

import { ReportData, ReportFilter, ValueLabelResponse } from 'types';

export const createFilterItem = (
  name: string,
  header: string,
  items: ValueLabelResponse[] | undefined,
  allowMultiSelect?: boolean | undefined,
  isSearchText?: boolean | undefined
): ReportFilter => {
  return {
    name,
    header,
    items: items ?? [],
    selectedItems: [],
    allowMultiSelect: allowMultiSelect ?? true,
    isSearchText: isSearchText ?? false,
  };
};

export const createColumnItem = (
  filter: string,
  header: string,
  width = 'auto',
  allowSortBy = false,
  isDate = false,
  formatLocaleDate?: FormatLocaleDateReturnType
): DataTableColumns<ReportData> => {
  const columnItem: DataTableColumns<ReportData> = {
    accessor: filter,
    disableSortBy: !allowSortBy,
    Header: () => header,
    width,
  };

  if (isDate) {
    columnItem.Cell = (cellProps: { value: string }) => {
      return formatLocaleDate ? formatLocaleDate(cellProps.value) : cellProps.value;
    };
  }

  return columnItem;
};

export const createColumnItemDate = (
  filter: string,
  header: string,
  formatLocaleDate?: FormatLocaleDateReturnType,
  width = '130px',
  allowSortBy = true
): DataTableColumns<ReportData> =>
  createColumnItem(filter, header, width, allowSortBy, true, formatLocaleDate);
